module.exports = __webpack_public_path__ + "media/images/linkedin-1b48200d94f3e2c54dd83230a54f1006.png";